import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectChatCompletionsState = (state: RootState) =>
  state.chatCompletionState;

export const selectMessages = createSelector(
  selectChatCompletionsState,
  (state) => state.messages
);

export const selectMessageLoading = createSelector(
  selectChatCompletionsState,
  (state) => state.isMessageLoading
);
